const mapping = {
  '158101766073': {
    make: 'toyota',
    imageSrc:
      'https://vexstockimages.fastly.carvana.io/stockimages/2020_TOYOTA_RAV4%20HYBRID_LIMITED%20SPORT%20UTILITY%204D_BLUE_stock_desktop_1920x1080.png?v=1645588168.586'
  },
  '156079649949': {
    make: 'honda',
    imageSrc:
      'https://vexstockimages.fastly.carvana.io/stockimages/2016_HONDA_CIVIC_TOURING%20COUPE%202D_BLACK_stock_desktop_1920x1080.png?v=1645516420.857'
  }
};

const defaultImageSrc =
  'https://vexstockimages.fastly.carvana.io/stockimages/2021_JEEP_CHEROKEE_LATITUDE%20LUX%20SPORT%20UTILITY%204D_BLUE_stock_desktop_1920x1080.png?v=1674835607.894';

export const getVehicleImage = (campaignId: string) =>
  mapping[campaignId]?.imageSrc || defaultImageSrc;

export const getVehicleMake = (campaignId: string) => mapping[campaignId]?.make;

export const hasMapping = (campaignId: string) => !!mapping[campaignId];
